import { useFiltersListener } from '@/hooks/use-filters'

import ListingMap from './map'
import { MapListProvider } from './maplist-context'

const ListingsMap = ({ initialListVisible, setFilterDefaultCity = true }) => {
  useFiltersListener({
    setDefaultCity: setFilterDefaultCity
  })

  return (
    <MapListProvider initialListVisible={initialListVisible}>
      <ListingMap />
    </MapListProvider>
  )
}

export default ListingsMap
